// src/components/PageHeader.jsx
import React, {useState} from "react";
import "./PageHeader.css";

const PageHeader = () => {
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    return (
        <header className="page-header">
            <div className="header-logo">软硬件开发解决方案</div>
            <nav className="header-nav">
                <a href="https://koolmirror.openpop.cn/">koolmirror</a>
                <a href="#contact" onClick={handleOpenModal}>联系我们</a>
                {showModal && (
                    <div className="modal-overlay" onClick={handleCloseModal}>
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <h2>联系方式</h2>
                            <p>电话：15972140296</p>
                            <p>邮箱：251805815@qq.com</p>
                            <button className="btn btn-primary" onClick={handleCloseModal}>关闭</button>
                        </div>
                    </div>
                )}
            </nav>
        </header>
    );
};

export default PageHeader;
